import { PropsWithChildren, useEffect } from 'react';

import { useLocation, useSearchParams } from 'react-router-dom';

import { SearchParamsEnum } from '@/enum/searchParams.enum';
import { StorageKeysEnum } from '@/enum/storageKeys.enum';

import { useAuth } from '@/hooks/useAuth';
import { useLangDetection } from '@/hooks/useLangDetection';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import { useRedirectUrl } from '@/hooks/useRedirectUrl';

export const AppWrapper = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const clientToken = searchParams.get(SearchParamsEnum.token);

  const { setItem: setToken } = useLocalStorage<string>(StorageKeysEnum.token);

  const { handleLogin } = useAuth();
  useLangDetection();
  useRedirectUrl();

  useEffect(() => {
    if (!clientToken) return;

    // Update the token in the local storage
    setToken(clientToken);

    handleLogin();
  }, [clientToken, setToken, handleLogin]);

  useEffect(
    () => window.parent.postMessage({ type: 'scrollTop' }, '*'),
    [pathname],
  );

  return <>{children}</>;
};
